module.exports = __webpack_public_path__ + "static/media/Group 2226.2803a3d5.svg";